<i18n>
{
  "en": {
    "engineeringLoadingError": "Error loading menus. Please, try it later.",
    "periodEngineeringProfitabilityError": "Error loading menus profitability data. Please, try it later."
  },
  "es": {
    "engineeringLoadingError": "Error cargando datos de rentabilidad de menús",
    "periodEngineeringProfitabilityError": "Error cargando datos de rentabilidad de menús. Inténtelo de nuevo más tarde."
  }
}
</i18n>

<template>
  <router-view @reload-profitability="reloadIfNecessary"/>
</template>

<script>

import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { MapActions, MapGetters } from '@core/helpers/decorators';
import { createErrorNotification } from '@ulibs/unnotificationsqueue';
import { sentryLogException } from '@core/helpers/sentryLogger';

@Component
@MapGetters(['isEngineeringProfitabilityLoading', 'menuEngineeringProfitabilityList'])
@MapActions(['addNotification', 'predictionPeriodRequest', 'setLoading',
  'periodEngineeringProfitabilityRequest', 'setEngineeringProfitabilityLoading'])
export default class MenuEngineering extends Vue {
  created() {
    this.reloadIfNecessary();
  }

  reloadIfNecessary() {
    if (this.menuEngineeringProfitabilityList.length === 0) {
      this.loadPeriodEngineeringProfitability();
    }
  }

  async loadPeriodEngineeringProfitability() {
    if (!this.isEngineeringProfitabilityLoading) {
      try {
        await this.setEngineeringProfitabilityLoading(1);
        const { periodGuid } = this.$route.params;
        await this.periodEngineeringProfitabilityRequest(periodGuid);
      } catch (err) {
        sentryLogException(err, 'Error loading menus profitability data');
        this.addNotification(createErrorNotification(this.$t('periodEngineeringProfitabilityError')));
      } finally {
        await this.setEngineeringProfitabilityLoading(-1);
      }
    }
  }

  @Watch('$route')
  onRouteChange(to, from) {
    if (to.params.pointOfSaleGuid !== from.params.pointOfSaleGuid) {
      this.$router.push({ name: 'restaurant-management' });
    }
  }
}
</script>
